module.exports = __webpack_public_path__ + "static/media/Lake-Village-II-Noise-Policy.d2cb94eb.pdf";